/** The order fields that name who delivers it; which one applies depends on the delivery type (N37). */
export const DELIVERY_ASSIGNEE_FIELDS = [
    'carrierId',
    'carrierServiceId',
    'deliveryDriverUserId',
];
//# sourceMappingURL=delivery-assignee-fields.js.map